import React, { use, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppInfo from "../../Pages/Report/AppInfo";
import AboutProject from "../../Pages/Report/AboutProject";
import { useDispatch, useSelector } from "react-redux";
import { GetSpecificRowReport } from "../../Redux/Reducers/ReportStage/Report";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import IndirectBeneficiaries from "../../Pages/Report/IndirectBeneficiaries";
import SubObjectivesForStage from "../../Pages/Report/SubObjectivesForStage";
import BudgetItemsForStage from "../../Pages/Report/BudgetItemsForStage";
import ActivitesForStage from "../../Pages/Report/ActivitesForStage";
import ButtonAHSF from "../../Components/ButtonAHSF";

import {
  ChangeStatusReportStage,
  GetSpecificRowReportStage,
  ValidationPageReport,
} from "../../Redux/Reducers/ReportStage/StartProgressReport";
import NoteTable from "../../Pages/Report/NoteTable";

import {
  GetRoleByUserGuid,
  HandelRolePageFunction,
} from "../../Redux/Reducers/Shared/RoleByUser";
import AttachedAccreditationReport from "../../Pages/Report/AttachedAccreditationReport";

import { ReturnToEdit } from "../../Redux/Reducers/ReportStage/ReturnComments";
import Swal from "sweetalert2";

function ReportStageForm() {
  const ReturnToEditResult = useSelector(
    (state) => state.ReturnComments.ReturnToEdit
  );
  const navigator = useNavigate();
  const [newAddedAttachment, setNewAddedAttachment] = useState(null);
  const [loding, setLoding] = useState(false);
  const HandelRolePageResult = useSelector(
    (state) => state.RoleByUserGuid.HandelRolePage
  );
  const userInfo = useSelector((state) => state.UserInfo.UserInfo);
  const [showHideButton, setShowHideButton] = useState(false);
  const [disabled, setDisabled] = useState(false);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const reportStage = useSelector(
    (state) => state.StartProgressReportReducer.ReportStage
  );
  const userRole = useSelector((state) =>
    state.RoleByUserGuid?.RoleByUserGuid?.map((role) => role.rolesId)
  );

  const arrayDataCheckBoksactivitiesForStageList = useSelector(
    (state) =>
      state.arrayDataCheckBoks?.arrayDataCheckBoks["activitiesForStage"]
  );
  const arrayDataCheckBokssubObjectivesForStageList = useSelector(
    (state) =>
      state.arrayDataCheckBoks?.arrayDataCheckBoks["subObjectivesForStage"]
  );
  const arraybudgetItemsForStageList = useSelector(
    (state) =>
      state.arrayDataCheckBoks?.arrayDataCheckBoks["budgetItemsForStage"]
  );

  const { reportId, reportStageId } = useParams();
  const navigate = useNavigate();
  const ReportRow = useSelector((state) => state.ReportStatus.ReportRow);
  useEffect(() => {
    dispatch(GetSpecificRowReport({ reportId: reportId }));
  }, [reportId]);
  const ChangeStatusReportStageFunction = async (StatusId) => {
    let resultChangeStatusReportStage = false;
    if (StatusId == "d26521bd-fd96-4a22-bffa-99c953cdc3b2") {
      var resultValidate = await dispatch(
        ValidationPageReport({
          reportStageId: reportStageId,
        })
      );
      console.log(resultValidate?.payload, "sdwddwdwwwwwwdwd");
      if (resultValidate?.payload?.success) {
        Swal.fire({
          title: "الرجاء تعبئة الحقول التالية",
          html: `
                                            <div style="text-align: right; direction: rtl; font-size: 16px;">
                                              <ul style="list-style-type: none; padding: 0;">${resultValidate?.payload?.result
                                                .map(
                                                  (field) =>
                                                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                                )
                                                .join("")}</ul>`,
          icon: "warning",
          confirmButtonText: "حسناً",
        });
        return;
      } else {
        dispatch(
          (resultChangeStatusReportStage = await ChangeStatusReportStage({
            reportStageId: reportStageId,
            reportStatusId: StatusId,
          }))
        );
        navigator("/SRFund/ReportStage");
      }

      if (resultChangeStatusReportStage?.payload?.success) {
        navigator("/SRFund/ReportStage");
      }
    } else if (StatusId == "8d983649-264c-4e4f-883f-c757840c97a3") {
      if (newAddedAttachment == null) {
        Swal.fire({
          title: "الرجاء تعبئة الحقول التالية",
          html: `
                                            <div style="text-align: right; direction: rtl; font-size: 16px;">
                                              <ul style="list-style-type: none; padding: 0;">
                                             <li style="margin-bottom: 8px;">🔸 <strong>مرفق محضر الاعتماد حقل اجباري</strong></li>
                                                </ul>`,
          icon: "warning",
          confirmButtonText: "حسناً",
        });
        return;
      } else {
        dispatch(
          (resultChangeStatusReportStage = await ChangeStatusReportStage({
            reportStageId: reportStageId,
            reportStatusId: StatusId,
          }))
        );
        navigator("/SRFund/report/ReportStageRequest/");
      }
    }else if (StatusId == "1432bd3b-061a-4068-8c0e-5b7c46d47e37") {
       dispatch(
          (resultChangeStatusReportStage = await ChangeStatusReportStage({
            reportStageId: reportStageId,
            reportStatusId: StatusId,
          }))
        );
        navigator("/SRFund/report/ReportStageRequest/");
    }
  };

  const [buttonApprovalProgressReport, setButtonApprovalProgressReport] =
    useState(null);
  const [buttonConversionAccreditation, setButtonConversionAccreditation] =
    useState(null);
  const [buttonReturnEdit, setButtonReturnEdit] = useState(null);
  const [buttonSubmittor, setButtonSubmittor] = useState(null);
  const [iconsAdd, setIconsAdd] = useState(null);
  const [iconsEditOrView, setIconsEditOrView] = useState(null);

  useEffect(() => {
    if (HandelRolePageResult?.loding) {
      setButtonReturnEdit(HandelRolePageResult?.buttonReturnEdit);
      setButtonSubmittor(HandelRolePageResult?.buttonSubmittor);
      setIconsAdd(HandelRolePageResult?.iconsAdd);
      setIconsEditOrView(HandelRolePageResult?.iconsEditOrView);
    }
  }, [HandelRolePageResult]);

  useEffect(() => {
    if (reportStageId != null && reportStageId != undefined) {
      dispatch(GetSpecificRowReportStage({ reportStageId: reportStageId }));
      dispatch(
        HandelRolePageFunction({
          reportStageId: reportStageId,
          userGuid: userInfo?.userToken?.userGuid,
        })
      );
    }
  }, [reportStageId]);

  // const ReturnToEditFunction = async () => {
  //   let result = await dispatch(
  //     ReturnToEdit({
  //       subObjectivesList:
  //         arrayDataCheckBokssubObjectivesForStageList == undefined
  //           ? []
  //           : arrayDataCheckBokssubObjectivesForStageList,
  //       activitiesForStage:
  //         arrayDataCheckBoksactivitiesForStageList == undefined
  //           ? []
  //           : arrayDataCheckBoksactivitiesForStageList,
  //       budgetItemsForStage:
  //         arraybudgetItemsForStageList == undefined
  //           ? []
  //           : arraybudgetItemsForStageList,
  //       reportStageId: reportStageId,
  //     })
  //   );
  //   if (result.payload.success == false) {
  //     Swal.fire({
  //       title: "الرجاء تعبئة الحقول التالية",
  //       html: `
  //                                           <div style="text-align: right; direction: rtl; font-size: 16px;">
  //                                             <ul style="list-style-type: none; padding: 0;">
  //                                             <li style="margin-bottom: 8px;">🔸 <strong>${result.payload.message}</strong></li>
  //                                               </ul>`,
  //       icon: "warning",
  //       confirmButtonText: "حسناً",
  //     });
  //     return;
  //   } else {
  //     // navigator("/SRFund/report/ReportStageRequest/")
  //   }
  // };
  const ReturnToEditFunction = async () => {
    let result = await dispatch(
      ReturnToEdit({
        subObjectivesList: arrayDataCheckBokssubObjectivesForStageList ?? [],
        activitiesForStage: arrayDataCheckBoksactivitiesForStageList ?? [],
        budgetItemsForStage: arraybudgetItemsForStageList ?? [],
        reportStageId: reportStageId,
      })
    );

    if (result.payload.success === false) {
      Swal.fire({
        title: "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align: right; direction: rtl; font-size: 16px;">
          <ul style="list-style-type: none; padding: 0;">
            <li style="margin-bottom: 8px;">🔸 <strong>${result.payload.message}</strong></li>
          </ul>
        </div>`,
        icon: "warning",
        confirmButtonText: "حسناً",
      });
      return;
    } else {
      await Swal.fire({
        icon: "success",
        title: "تم إرجاع الطلب للتعديل بنجاح",
        confirmButtonText: "حسناً",
      });
      navigate("/SRFund/report/ReportStageRequest/");
    }
  };

  console.log(HandelRolePageResult, "reportStageeeeddcdvdvfdfeeeeeeeeee");

  return (
    <>
      {reportStage?.reportStageId && HandelRolePageResult?.loding ? (
        <>
          <>
            <AppInfo reportId={reportId} />
            <AboutProject
              disabled={true}
              ReportRow={ReportRow}
              setOverallProjectObjective={null}
              setExpectedProjectDeliverables={null}
              setAgreementAttachment={null}
              reportId={reportId}
            />
            <SharedDiv
              showTitle={true}
              titleName="الإنجازات العامة"
              child={[
                <>
                  <ActivitesForStage
                    buttonSubmittor={HandelRolePageResult.buttonSubmittor}
                    iconsEditOrView={HandelRolePageResult.iconsEditOrView}
                    iconsAdd={HandelRolePageResult.iconsAdd}
                    reportStageId={reportStageId}
                    checkBoks={HandelRolePageResult.buttonReturnEdit}
                  />
                </>,
              ]}
            />

            <SharedDiv
              showTitle={true}
              titleName="الاهداف الفرعية"
              child={[
                <>
                  <SubObjectivesForStage
                    buttonSubmittor={HandelRolePageResult.buttonSubmittor}
                    iconsEditOrView={HandelRolePageResult.iconsEditOrView}
                    iconsAdd={HandelRolePageResult.iconsAdd}
                    reportStageId={reportStageId}
                    checkBoks={HandelRolePageResult.buttonReturnEdit}
                  />
                </>,
              ]}
            />

            <SharedDiv
              showTitle={true}
              titleName="تقرير المصروف الفعلي"
              child={[
                <>
                  <BudgetItemsForStage
                    buttonSubmittor={HandelRolePageResult.buttonSubmittor}
                    iconsEditOrView={HandelRolePageResult.iconsEditOrView}
                    iconsAdd={HandelRolePageResult.iconsAdd}
                    reportStage={HandelRolePageResult.reportStage}
                    reportStageId={reportStageId}
                    checkBoks={buttonReturnEdit}
                  />
                </>,
              ]}
            />
            <SharedDiv
              showTitle={true}
              titleName="مستفيدين غير مباشرين"
              child={[
                <>
                  <IndirectBeneficiaries
                    buttonSubmittor={HandelRolePageResult.buttonSubmittor}
                    iconsEditOrView={HandelRolePageResult.iconsEditOrView}
                    iconsAdd={HandelRolePageResult.iconsAdd}
                    reportStage={HandelRolePageResult.reportStage}
                    reportStageId={reportStageId}
                    checkBoks={buttonReturnEdit}

                    // reportStageId={reportStageId}
                  />
                </>,
              ]}
            />

            {buttonReturnEdit ? (
              <>
                <SharedDiv
                  showTitle={true}
                  titleName="الملاحظات"
                  child={[
                    <>
                      <NoteTable reportStageId={reportStageId} />
                      
                      <AttachedAccreditationReport
                        setNewAddedAttachment={setNewAddedAttachment}
                        reportStageId={reportStageId}
                        reportStage={reportStage}
                      />
                    </>,
                  ]}
                />
              </>
            ) : (
              <></>
            )}

            {/* <SharedDiv
              showTitle={true}
              titleName="الإجراءات على الطلب"
              child={[
                <>
                  <div
                    className="containerButtonMAin "
                    style={{ justifyContent: "center" }}
                  >
                    {HandelRolePageResult.buttonSubmittor ? (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            ChangeStatusReportStageFunction(
                              "d26521bd-fd96-4a22-bffa-99c953cdc3b2"
                            );
                          }}
                          disabled={false}
                          title={"تقديم التقرير المرحلي"}
                          text={"تقديم التقرير المرحلي"}
                          show={true}
                        />
                      </>
                    ) : (
                      <></>
                    )}

                    {HandelRolePageResult.buttonConversionAccreditation ? (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            ChangeStatusReportStageFunction(
                              "8d983649-264c-4e4f-883f-c757840c97a3"
                            );
                          }}
                          disabled={false}
                          title={"مراجعة التقرير المرحلي"}
                          text={"مراجعة التقرير المرحلي"}
                          show={true}
                        />
                      </>
                    ) : (
                      <></>
                    )}

                    {HandelRolePageResult.buttonApprovalProgressReport ? (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            ChangeStatusReportStageFunction(
                              "d26521bd-fd96-4a22-bffa-99c953cdc3b2"
                            );
                          }}
                          disabled={false}
                          title={"اعتماد التقرير المرحلي"}
                          text={"اعتماد التقرير المرحلي"}
                          show={true}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    {HandelRolePageResult.buttonReturnEdit ? (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={ReturnToEditFunction}
                          disabled={false}
                          title={"ارجاع للتعديل"}
                          text={"ارجاع للتعديل"}
                          show={true}
                        />
                      </>
                    ) : (
                      <></>
                    )}

                    <></>
                  </div>
                </>,
              ]}
            /> */}
            {(HandelRolePageResult.buttonSubmittor ||
              HandelRolePageResult.buttonConversionAccreditation ||
              HandelRolePageResult.buttonApprovalProgressReport ||
              HandelRolePageResult.buttonReturnEdit) && (
              <SharedDiv
                showTitle={true}
                titleName="الإجراءات على الطلب"
                child={[
                  <>
                    <div
                      className="containerButtonMAin"
                      style={{ justifyContent: "center" }}
                    >
                      {HandelRolePageResult.buttonSubmittor && (
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            ChangeStatusReportStageFunction(
                              "d26521bd-fd96-4a22-bffa-99c953cdc3b2"
                            );
                            // Swal.fire({
                            //   position: "center",
                            //   icon: "success",
                            //   title: "تم تقديم التقرير المرحلي",
                            //   showConfirmButton: false,
                            //   timer: 1000,
                            // });
                          }}
                          disabled={false}
                          title={"تقديم التقرير المرحلي"}
                          text={"تقديم التقرير المرحلي"}
                          show={true}
                        />
                      )}

                      {HandelRolePageResult.buttonConversionAccreditation && (
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            ChangeStatusReportStageFunction(
                              "8d983649-264c-4e4f-883f-c757840c97a3"
                            );
                          }}
                          disabled={false}
                          title={"مراجعة التقرير المرحلي"}
                          text={"مراجعة التقرير المرحلي"}
                          show={true}
                        />
                      )}

                      {HandelRolePageResult.buttonApprovalProgressReport && (
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            ChangeStatusReportStageFunction(
                              "1432bd3b-061a-4068-8c0e-5b7c46d47e37"
                            );
                          }}
                          disabled={false}
                          title={"اعتماد التقرير المرحلي"}
                          text={"اعتماد التقرير المرحلي"}
                          show={true}
                        />
                      )}

                      {HandelRolePageResult.buttonReturnEdit && (
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            Swal.fire({
                              // title: "هل أنت متأكد؟",
                              title: "هل أنت متأكد من إرجاع الطلب للتعديل؟",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonText: "نعم، أرجع للتعديل",
                              cancelButtonText: "إلغاء",
                              reverseButtons: true,
                            }).then((result) => {
                              if (result.isConfirmed) {
                                ReturnToEditFunction();
                              }
                            });
                          }}
                          disabled={false}
                          title={"ارجاع للتعديل"}
                          text={"ارجاع للتعديل"}
                          show={true}
                        />
                      )}
                    </div>
                  </>,
                ]}
              />
            )}
          </>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default ReportStageForm;
